import React from 'react';
import { TaxComparisonTable as TaxComparisonTable$1 } from '@zillow/zrs-traffic';

var BlockTaxComparisonTable = function BlockTaxComparisonTable() {
  return /*#__PURE__*/React.createElement(TaxComparisonTable$1, null);
};
var TaxComparisonTable = BlockTaxComparisonTable;

export { TaxComparisonTable as default };
